import React, { useEffect, useState } from 'react'
import {useNavigate, Link} from "react-router-dom";
import axios from 'axios';
import gr_bg_1 from '../photos/GR_home_bg.jpg'
import gr_bg_2 from '../photos/margarita.webp'
import gr_bg_3 from '../photos/GR_beer_tap.jpg'
import gr_border from '../icons/GR_border_design_brown.jpg'

import Navbar from '../components/Navbar/Navbar.jsx';
const Home = (props) => {
    const navigate = useNavigate();
    return (
        <div id='home-page' className='home-page'>
            <div className='home-container-1'>
                {/* <img className='bg-img' src={gr_bg_1} alt="" /> */}
                <div className='home-name'>
                    <h2 className='gr-title'>Gran Rodeo</h2>
                    <h1 className='gr-subtitle'>Mexican Bar & Grill</h1>
                </div>
            </div>
            {/* <div className="border-img"></div> */}
            <div id='hours-of-operation' className="home-section">
                <div  className='container text-container hours-of-operation'>
                    <div>

                        <h3>Hours of Operation</h3>
                        <div>
                            <span>Mon - Thurs</span>
                            <span>11:00am - 10:00pm</span>
                        </div>
                        <div>
                            <span>Fri</span>
                            <span>11:00am - 11:00pm</span>
                        </div>
                        <div>
                            <span>Sat</span>
                            <span>11:00am - 10:30pm</span>
                        </div>
                        <div>
                            <span>Sun</span>
                            <span>11:00am - 9:30pm</span>
                        </div>
                    </div>
                    <div>
                        <h3>HAPPY HOUR</h3>
                        <div>
                            <span>Mon - Thurs</span>
                            <span>3:00pm - 5:00pm</span>
                        </div>
                    </div>
                </div>
                <div className='home-section-title'>
                    <h2>hours</h2>
                </div>
            </div>
            
            <div className="home-section home-section-rev">
                {/* <div className='border-img'></div> */}
                <div className='about container text-container'>
                    <p>At Gran Rodeo our passion for delicious authentic Mexican food and exceptional service is at the core of who we are. Family owned and operated since 1993, we are committed to wholeheartedly serving each and every guest we meet.</p>
                    <p>From quesadillas to street tacos, fresh margaritas to fried ice cream, Gran Rodeo offers a wide variety of options to suit everyone's tastes.</p>
                    <p>All dishes are made fresh daily with only the highest quality ingredients. Gluten-free and vegetarian options available.</p>
                    <p>Contact us for your next special occasion, large group reservation, or event catering! </p>
                </div>
                <div className="home-section-title">
                    <h2>about</h2>
                </div>
            </div>
        </div>
    )
}
export default Home;
